<template>
  <div class="container-table-striped">
    <div class="table-hover">
      <table class="table content-table-striped table-striped mb-5">
        <thead>
          <tr class="row global-thead-dark thead-property pl-1">
            <th class="col-4">
              Nombre
            </th>
            <th class="col-4">
              Puesto
            </th>
            <th class="col-4" />
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in items" :key="'ps' + index" class="row">
            <td class="col">
              <ValidationProvider v-slot="{ errors }" rules="required">
                <CustomInput
                  v-model="item.name"
                  placeholder="Escribir Nombre"
                  :error="errors[0]"
                  custom-error-msg=""
                  :disabled="disabled"
                />
                <Error
                  v-if="errors[0]"
                  variant="no-border error-margin-left"
                  message="El campo es requerido."
                />
              </ValidationProvider>
            </td>
            <td class="col">
              <ValidationProvider v-slot="{ errors }" rules="required">
                <CustomDropDown
                  v-model="item.position"
                  required
                  :options="[]"
                  fieldkey="id"
                  fieldname="name"
                  label=""
                  placeholder="Seleccione"
                  :error="errors[0]"
                  :disabled="disabled"
                />
                <Error
                  v-if="errors[0]"
                  variant="no-border error-margin-left"
                  message="El campo es requerido."
                />
              </ValidationProvider>
            </td>
            <td class="col">
              <div class="dropdown">
                <button
                  id="dropdownMenuButton"
                  class="btn btn-dropdown-actions dropdown-toggle float-right pt-1"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  :disabled="disabled"
                >
                  Acciones
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <div class="dropdown-item">
                    <em class="fa fa-pencil text-green pr-1" />
                    <span>Editar</span>
                  </div>
                  <div class="dropdown-item">
                    <em class="fa fa-times-circle text-red pr-1" />
                    <span>Eliminar</span>
                  </div>
                  <a class="dropdown-item" href="#" />
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { CustomInput, CustomDropDown, Error } from '@/components/common';
export default {
  name: 'ParticipantSignature',
  data() {
    return {
      items: [
        { id: 1, name: '', position: null },
        { id: 2, name: '', position: null },
        { id: 3, name: '', position: null },
      ],
    };
  },
  props: {
    disabled: {
      type: Boolean,
      default: () => false,
    },
  },
  components: {
    CustomInput,
    CustomDropDown,
    Error,
  },
};
</script>

<style scoped>
.thead-property {
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px 5px 0px 0px;
}

.btn-dropdown-actions {
  text-align: center;
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
  width: 7.8125rem;
  height: 2.25rem;
}

.drop-item {
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 0.9375rem;
  color: #11291b;
  text-align: inherit;
  white-space: nowrap;
  display: block;
  padding: 0.29rem 1.5rem;
  clear: both;
}

.drop-item:hover {
  text-decoration: none;
  color: #727272;
}

.btn-dropdown-actions {
  text-align: center;
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
  width: 7.8125rem;
  height: 2.25rem;
}

.error-margin-left {
  margin-left: -20px !important;
}
</style>
